var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g, _path24, _path25, _path26, _g2, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _g3, _path62, _path63, _path64, _path65, _g4, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _g5, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _g6, _path209, _path210, _path211, _g7, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApartmentRentBro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M67.93 167.09C67.93 167.09 40.05 239.09 79.23 311.59C118.41 384.09 199.11 422.39 263.7 455.14C328.29 487.89 395.36 471.94 427.23 418.3C459.1 364.66 415.39 326.37 415.33 249.88C415.27 173.39 426.78 153.14 385.33 88.5199C343.88 23.8999 242.27 9.58995 165.43 57.52C88.59 105.45 67.93 167.09 67.93 167.09Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.86 157C109.69 103.93 182.18 42 281.65 67.7999C381.12 93.5999 448.31 148.17 437.3 243.13C426.29 338.09 368.42 417 243.78 419.3C119.14 421.6 17.66 273.34 80.86 157Z",
    fill: "#DE3C3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M80.86 157C109.69 103.93 182.18 42 281.65 67.7999C381.12 93.5999 448.31 148.17 437.3 243.13C426.29 338.09 368.42 417 243.78 419.3C119.14 421.6 17.66 273.34 80.86 157Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77 145.12C77 145.12 79.51 135.49 96.42 135.44C113.33 135.39 123.24 152.31 123.24 152.31C123.24 152.31 130.33 144.94 138.9 149.86C147.47 154.78 147.45 157.57 147.45 157.57H169.45",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M434.06 160.45C434.06 160.45 431.55 150.81 414.64 150.76C397.73 150.71 387.82 167.64 387.82 167.64C387.82 167.64 380.73 160.27 372.16 165.19C363.59 170.11 363.61 172.9 363.61 172.9H341.61",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M393.46 143H381.06C381.06 143 384.45 135.85 376.79 127.39C369.13 118.93 361.34 124.56 361.34 124.56C361.34 124.56 353.82 98.82 331.89 101.84C309.96 104.86 307.65 126 307.65 126C307.65 126 302.96 120.81 293.41 124.22C283.86 127.63 282.41 140.7 284.78 146.22C284.78 146.22 273.91 148.33 273.18 157.61C273.18 157.61 272.51 149.4 262.28 149.15C252.05 148.9 249.49 161.6 249.49 161.6H238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M114.31 124.58L171.67 121.72C177.98 100.63 201.84 109.45 201.84 109.45C210.87 87.57 232 98 232 98C232 98 242.72 76.92 263.88 81.33C269.844 82.4505 275.383 85.1982 279.883 89.2696C284.383 93.341 287.67 98.5774 289.38 104.4L303.98 105.01",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.08 339.36V278.82H95.58L103.88 270.51V258.51H106.65V312.43",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.14 348.16V316.58H126.62V374.3",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M114.31 312.43V291.98H126.62V274.86H129.86V247.32H132.46V268.27H136.19V292.5L141.19 297.5V311.06H150.43",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M135.05 377.98V340.22H143.04V322.02H153.59V292.5H158.4",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M370.38 321.1V312.43H364.06V295.59H361.42V312.23H351.17V319.26",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M402.89 313.4V292.11L390.43 279.65H385.68V295.59H382.52V298.44H385.68V324.02H358.25V366.83V390.29",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M393.46 368.03V316.58H419.97V329.52",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M411 312.43V274.86H413.64V312.43",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M351.17 387.95V351.31H324.7V303.37L303.23 281.89V259.52H298.66V353.28",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M306.08 398.53V358.25H277.91V330.65H274.24V291.15H270.86V253.55H266.35V208.41H262.39V251.83L257.16 257.05V278.82H247.66V330.61H228.52V363.6H215.78V398.53",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M161.39 311.06H176.31V347.19H188.15V376.81",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M178.64 323.3H188.15V289.18H233.5V324.02",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M278.13 316.58H294.31",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M337.16 348.16V284.62H333.73V349",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M333.73 143.5V174.49H330.62V148.3H311.66V174.49H308.55V148.3H201.31V174.49H198.2V148.3H179.24V174.49H176.13V143.5H333.73Z",
    fill: "#DE3C3E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_387",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 176,
    y: 143,
    width: 158,
    height: 32
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M333.73 143.5V174.49H330.62V148.3H311.66V174.49H308.55V148.3H201.31V174.49H198.2V148.3H179.24V174.49H176.13V143.5H333.73Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_387)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M333.73 143.5V156.66H330.62V148.3H311.66V156.66H308.55V148.3H201.31V156.66H198.2V148.3H179.24V156.66H176.13V143.5H333.73Z",
    fill: "black"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M333.73 143.5V174.49H330.62V148.3H311.66V174.49H308.55V148.3H201.31V174.49H198.2V148.3H179.24V174.49H176.13V143.5H333.73Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M329.1 136.73H285.37H264.19H180.47L158.4 150.26H243.16H276.4H351.17L329.1 136.73Z",
    fill: "#DE3C3E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_387",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 158,
    y: 136,
    width: 194,
    height: 15
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M329.1 136.73H285.37H264.19H180.47L158.4 150.26H243.16H276.4H351.17L329.1 136.73Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_387)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M329.1 136.73H285.37H264.19H180.47L158.4 150.26H243.16H276.4H351.17L329.1 136.73Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M290.53 136.73H224.41V150.26H307.62L290.53 136.73Z",
    fill: "black"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M329.1 136.73H285.37H264.19H180.47L158.4 150.26H243.16H276.4H351.17L329.1 136.73Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M211.15 139.33H325.48",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M297.15 142.21H216.17",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M197.02 145.54H290.08",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M300.82 142.21H303.59",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M312.47 142.21H323.18",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M330.32 139.33H332.27",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M295.68 145.54H318.43",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M323.18 145.54H326.22",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M333.73 145.54H343.46",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M171.53 142.21H192.62",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M203.3 142.21H206.08",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M203.3 139.33H182.07",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M176.13 145.54H181.15",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M342.09 173.59V396.32C315.5 410.32 282.93 418.57 243.78 419.32C217.268 419.681 191.071 413.553 167.47 401.47V173.59H342.09Z",
    fill: "#DE3C3E",
    stroke: "#DE3C3E",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M342.09 173.59V396.32C315.5 410.32 282.93 418.57 243.78 419.32C217.268 419.681 191.071 413.553 167.47 401.47V173.59H342.09Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M290.93 174.49H283.2V413.66H290.93V174.49Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M205.29 401.33L201.31 411.33V177.55L205.29 187.55V401.33Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M310.35 386.79L317.93 394.37H342.09V386.79H310.35Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M310.35 342.62L317.93 350.2H342.09V342.62H310.35Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M310.35 298.44L317.93 306.02H342.09V298.44H310.35Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M310.35 254.27L317.93 261.85H342.09V254.27H310.35Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M310.35 210.1L317.93 217.68H342.09V210.1H310.35Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M167.35 386.79L174.93 394.37H201.09V386.79H167.35Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M167.35 342.62L174.93 350.2H201.09V342.62H167.35Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M167.35 298.44L174.93 306.02H201.09V298.44H167.35Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M167.35 254.27L174.93 261.85H201.09V254.27H167.35Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M167.35 210.1L174.93 217.68H201.09V210.1H167.35Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M169.87 163.75H339.69",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M169.87 166.28H339.69",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M169.87 168.81H339.69",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M169.87 171.34H339.69",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M339.69 161.5H169.87V173.59H339.69V161.5Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M353.33 148.3H156.23V151.57H353.33V148.3Z",
    fill: "#DE3C3E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_387",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 156,
    y: 148,
    width: 198,
    height: 4
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M353.33 148.3H156.23V151.57H353.33V148.3Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_387)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M353.33 148.3H156.23V151.57H353.33V148.3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M308.55 148.3H224.41V151.57H308.55V148.3Z",
    fill: "black"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M353.33 148.3H156.23V151.57H353.33V148.3Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M167.47 401.45V173.59H342.09V396.32",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M223.64 420.9V136.73H285.92V418.9",
    fill: "#DE3C3E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_387",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 223,
    y: 136,
    width: 63,
    height: 285
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M223.64 420.9V136.73H285.92V418.9",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_387)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M285.92 139.33H223.64V146.73H285.92V139.33Z",
    fill: "black"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M223.64 420.9V136.73H285.92V418.9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M245.55 181.69H228.28V194.85H245.55V181.69Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M245.05 182.19H237.42V194.35H245.05V182.19Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M244.55 182.69V193.85H237.92V182.69H244.55ZM245.55 181.69H236.92V194.85H245.55V181.69Z",
    fill: "#263238"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M197.09 181.69H170.43V206.94H197.09V181.69Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M179.24 181.69V206.94",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M196.1 182.69V205.94H189.15V182.69H196.1ZM197.1 181.69H188.15V206.94H197.1V181.69Z",
    fill: "#263238"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M199.21 206.94H161.39V210.23H199.21V206.94Z",
    fill: "#DE3C3E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M161.39 197.1H199.21",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M161.39 199.63H199.21",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M161.39 202.16H199.21",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M161.39 204.69H199.21",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M199.21 194.85H161.39V206.94H199.21V194.85Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M215.26 181.69H209.58V194.85H215.26V181.69Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M264.01 194.85H281.28V181.69H264.01V194.85Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M272.14 182.19H264.51V194.35H272.14V182.19Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M271.65 182.69V193.85H265V182.69H271.64M272.64 181.69H264V194.85H272.64V181.69Z",
    fill: "#263238"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M312.47 206.94H339.13V181.69H312.47V206.94Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M330.32 181.69V206.94",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M320.41 182.69V205.94H313.47V182.69H320.41ZM321.41 181.69H312.47V206.94H321.41V181.69Z",
    fill: "#263238"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M310.36 210.24H348.18V206.95H310.36V210.24Z",
    fill: "#DE3C3E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M348.17 197.1H310.35",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M348.17 199.63H310.35",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M348.17 202.16H310.35",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M348.17 204.69H310.35",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M310.36 206.95H348.18V194.86H310.36V206.95Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M294.3 194.85H299.98V181.69H294.3V194.85Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M245.55 225.83H228.28V238.99H245.55V225.83Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M245.05 226.33H237.42V238.49H245.05V226.33Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M244.55 226.83V238H237.92V226.83H244.55ZM245.55 225.83H236.92V239H245.55V225.83Z",
    fill: "#263238"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M197.09 225.83H170.43V251.08H197.09V225.83Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M179.24 225.83V251.08",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M196.1 226.83V250.08H189.15V226.83H196.1ZM197.1 225.83H188.15V251.08H197.1V225.83Z",
    fill: "#263238"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M199.21 251.08H161.39V254.37H199.21V251.08Z",
    fill: "#DE3C3E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M161.39 241.24H199.21",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M161.39 243.77H199.21",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M161.39 246.3H199.21",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M161.39 248.83H199.21",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M199.21 238.99H161.39V251.08H199.21V238.99Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M215.26 225.83H209.58V238.99H215.26V225.83Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M264.01 238.99H281.28V225.83H264.01V238.99Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M272.14 226.33H264.51V238.49H272.14V226.33Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M271.65 226.83V238H265V226.83H271.64M272.64 225.83H264V239H272.64V225.83Z",
    fill: "#263238"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M312.47 251.08H339.13V225.83H312.47V251.08Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M330.32 225.83V251.08",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M320.41 226.83V250.08H313.47V226.83H320.41ZM321.41 225.83H312.47V251.08H321.41V225.83Z",
    fill: "#263238"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M310.36 254.37H348.18V251.08H310.36V254.37Z",
    fill: "#DE3C3E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M348.17 241.24H310.35",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M348.17 243.77H310.35",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M348.17 246.3H310.35",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M348.17 248.83H310.35",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M310.36 251.08H348.18V238.99H310.36V251.08Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M294.3 238.99H299.98V225.83H294.3V238.99Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M245.55 269.97H228.28V283.13H245.55V269.97Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M245.05 270.47H237.42V282.63H245.05V270.47Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M244.55 271V282.16H237.92V271H244.55ZM245.55 270H236.92V283.16H245.55V270Z",
    fill: "#263238"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M197.09 269.97H170.43V295.22H197.09V269.97Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M179.24 269.97V295.22",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M196.1 271V294.25H189.15V271H196.1ZM197.1 270H188.15V295.25H197.1V270Z",
    fill: "#263238"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M199.21 295.22H161.39V298.51H199.21V295.22Z",
    fill: "#DE3C3E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M161.39 285.38H199.21",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M161.39 287.91H199.21",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M161.39 290.44H199.21",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M161.39 292.97H199.21",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M199.21 283.13H161.39V295.22H199.21V283.13Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M215.26 269.97H209.58V283.13H215.26V269.97Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M264.01 283.13H281.28V269.97H264.01V283.13Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M272.14 270.47H264.51V282.63H272.14V270.47Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M271.65 271V282.16H265V271H271.64M272.64 270H264V283.16H272.64V270Z",
    fill: "#263238"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M312.47 295.22H339.13V269.97H312.47V295.22Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M330.32 269.97V295.22",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M320.41 271V294.25H313.47V271H320.41ZM321.41 270H312.47V295.25H321.41V270Z",
    fill: "#263238"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M310.36 298.51H348.18V295.22H310.36V298.51Z",
    fill: "#DE3C3E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M348.17 285.38H310.35",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M348.17 287.91H310.35",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M348.17 290.44H310.35",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M348.17 292.97H310.35",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M310.36 295.22H348.18V283.13H310.36V295.22Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M294.3 283.13H299.98V269.97H294.3V283.13Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M245.55 314.11H228.28V327.27H245.55V314.11Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M245.05 314.61H237.42V326.77H245.05V314.61Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M244.55 315.11V326.27H237.92V315.11H244.55ZM245.55 314.11H236.92V327.27H245.55V314.11Z",
    fill: "#263238"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M197.09 314.11H170.43V339.36H197.09V314.11Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M179.24 314.11V339.36",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M196.1 315.11V338.36H189.15V315.11H196.1ZM197.1 314.11H188.15V339.36H197.1V314.11Z",
    fill: "#263238"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M199.21 339.36H161.39V342.65H199.21V339.36Z",
    fill: "#DE3C3E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M161.39 329.52H199.21",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M161.39 332.05H199.21",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M161.39 334.58H199.21",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M161.39 337.11H199.21",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M199.21 327.27H161.39V339.36H199.21V327.27Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M215.26 314.11H209.58V327.27H215.26V314.11Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M264.01 327.27H281.28V314.11H264.01V327.27Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M272.14 314.61H264.51V326.77H272.14V314.61Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M271.65 315.11V326.27H265V315.11H271.64M272.64 314.11H264V327.27H272.64V314.11Z",
    fill: "#263238"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M312.47 339.36H339.13V314.11H312.47V339.36Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M330.32 314.11V339.36",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M320.41 315.11V338.36H313.47V315.11H320.41ZM321.41 314.11H312.47V339.36H321.41V314.11Z",
    fill: "#263238"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M310.36 342.65H348.18V339.36H310.36V342.65Z",
    fill: "#DE3C3E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M348.17 329.52H310.35",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M348.17 332.05H310.35",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M348.17 334.58H310.35",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M348.17 337.11H310.35",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M310.36 339.36H348.18V327.27H310.36V339.36Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M294.3 327.27H299.98V314.11H294.3V327.27Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M245.55 358.25H228.28V371.41H245.55V358.25Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M245.05 358.75H237.42V370.91H245.05V358.75Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M244.55 359.25V370.41H237.92V359.25H244.55ZM245.55 358.25H236.92V371.41H245.55V358.25Z",
    fill: "#263238"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M197.09 358.25H170.43V383.5H197.09V358.25Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M179.24 358.25V383.5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M196.1 359.25V382.5H189.15V359.25H196.1ZM197.1 358.25H188.15V383.5H197.1V358.25Z",
    fill: "#263238"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M199.21 383.5H161.39V386.79H199.21V383.5Z",
    fill: "#DE3C3E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M161.39 373.66H199.21",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M161.39 376.19H199.21",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M161.39 378.72H199.21",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M161.39 381.25H199.21",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M199.21 371.41H161.39V383.5H199.21V371.41Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M215.26 358.25H209.58V371.41H215.26V358.25Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M264.01 371.41H281.28V358.25H264.01V371.41Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M272.14 358.75H264.51V370.91H272.14V358.75Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M271.65 359.25V370.41H265V359.25H271.64M272.64 358.25H264V371.41H272.64V358.25Z",
    fill: "#263238"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M312.47 383.5H339.13V358.25H312.47V383.5Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M330.32 358.25V383.5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M320.41 359.25V382.5H313.47V359.25H320.41ZM321.41 358.25H312.47V383.5H321.41V358.25Z",
    fill: "#263238"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M310.36 386.79H348.18V383.5H310.36V386.79Z",
    fill: "#DE3C3E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M348.17 373.66H310.35",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M348.17 376.19H310.35",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M348.17 378.72H310.35",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M348.17 381.25H310.35",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M310.36 383.5H348.18V371.41H310.36V383.5Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M294.3 371.41H299.98V358.25H294.3V371.41Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M285.92 143.5H223.64V156.66H285.92V143.5Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1_387",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 223,
    y: 143,
    width: 63,
    height: 14
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M285.92 143.5H223.64V156.66H285.92V143.5Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1_387)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M285.93 143.5H223.64V147.27H285.93V143.5Z",
    fill: "black"
  }))), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M285.92 143.5H223.64V156.66H285.92V143.5Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M230.66 143.5V156.66",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M238.7 143.5V156.66",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M246.74 143.5V156.66",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M254.78 143.5V156.66",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M262.82 143.5V156.66",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M270.86 143.5V156.66",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M278.91 143.5V156.66",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M293.79 137.7H215.78L226.81 124.16H282.75L293.79 137.7Z",
    fill: "#DE3C3E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1_387",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 215,
    y: 124,
    width: 79,
    height: 14
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M293.79 137.7H215.78L226.81 124.16H282.75L293.79 137.7Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1_387)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M293.79 137.7H215.78L226.81 124.16H282.75L293.79 137.7Z",
    fill: "black"
  }))), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M293.79 137.7H215.78L226.81 124.16H282.75L293.79 137.7Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M294.85 136.06H214.72V139.33H294.85V136.06Z",
    fill: "#DE3C3E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1_387",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 214,
    y: 136,
    width: 81,
    height: 4
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M294.85 136.06H214.72V139.33H294.85V136.06Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1_387)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M294.85 136.06H214.72V139.33H294.85V136.06Z",
    fill: "black"
  }))), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M294.85 136.06H214.72V139.33H294.85V136.06Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M231.23 162.87H237.06V160.53H231.23V162.87Z",
    fill: "black"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M235.9 165.54H241.73V163.2H235.9V165.54Z",
    fill: "black"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M252.29 178.73H258.12V176.39H252.29V178.73Z",
    fill: "black"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M249.37 181.82H255.2V179.48H249.37V181.82Z",
    fill: "black"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M228.32 202.72H234.15V200.38H228.32V202.72Z",
    fill: "black"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M231.51 205.63H237.34V203.29H231.51V205.63Z",
    fill: "black"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M265.46 208.41H271.29V206.07H265.46V208.41Z",
    fill: "black"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M262.38 211.53H268.21V209.19H262.38V211.53Z",
    fill: "black"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M230.16 223.77H235.99V221.43H230.16V223.77Z",
    fill: "black"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M234.85 202.72H240.68V200.38H234.85V202.72Z",
    fill: "black"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M259.17 268.27H253.34V270.61H259.17V268.27Z",
    fill: "black"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M233.5 265.59H227.67V267.93H233.5V265.59Z",
    fill: "black"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M241.12 250.41H235.29V252.75H241.12V250.41Z",
    fill: "black"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M244.03 247.32H238.2V249.66H244.03V247.32Z",
    fill: "black"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M262.08 228.42H256.25V230.76H262.08V228.42Z",
    fill: "black"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M258.89 225.5H253.06V227.84H258.89V225.5Z",
    fill: "black"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M272.81 169.57H266.98V171.91H272.81V169.57Z",
    fill: "black"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M275.89 166.45H270.06V168.79H275.89V166.45Z",
    fill: "black"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M274.15 218.91H268.32V221.25H274.15V218.91Z",
    fill: "black"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M255.55 228.42H249.72V230.76H255.55V228.42Z",
    fill: "black"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M279.53 251.83H273.7V254.17H279.53V251.83Z",
    fill: "black"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M274.86 249.15H269.03V251.49H274.86V249.15Z",
    fill: "black"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M259.48 374.97H253.65V377.31H259.48V374.97Z",
    fill: "black"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M273.39 393.87H267.56V396.21H273.39V393.87Z",
    fill: "black"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M284.44 354.97H278.61V357.31H284.44V354.97Z",
    fill: "black"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M281.25 352.06H275.42V354.4H281.25V352.06Z",
    fill: "black"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M236.3 353.28H230.47V355.62H236.3V353.28Z",
    fill: "black"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M239.38 350.16H233.55V352.5H239.38V350.16Z",
    fill: "black"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M282.6 333.92H276.77V336.26H282.6V333.92Z",
    fill: "black"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M277.91 354.97H272.08V357.31H277.91V354.97Z",
    fill: "black"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M250.2 355.12C255.87 355.06 261.71 355.06 267.2 355.12H250.2Z",
    fill: "black"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M240.6 286.42H246.43V284.08H240.6V286.42Z",
    fill: "black"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M245.26 289.1H251.09V286.76H245.26V289.1Z",
    fill: "black"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M258.65 304.28H264.48V301.94H258.65V304.28Z",
    fill: "black"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M255.73 338.37H261.56V336.03H255.73V338.37Z",
    fill: "black"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M237.68 322.28H243.51V319.94H237.68V322.28Z",
    fill: "black"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M240.88 325.19H246.71V322.85H240.88V325.19Z",
    fill: "black"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M235.95 386.12H241.78V383.78H235.95V386.12Z",
    fill: "black"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M232.87 389.24H238.7V386.9H232.87V389.24Z",
    fill: "black"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M225.61 331.77H231.44V329.43H225.61V331.77Z",
    fill: "black"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M244.21 322.28H250.04V319.94H244.21V322.28Z",
    fill: "black"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M224.37 378.15H230.2V375.81H224.37V378.15Z",
    fill: "black"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M229.05 375.47H234.88V373.13H229.05V375.47Z",
    fill: "black"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M273.33 381.07H279.16V378.73H273.33V381.07Z",
    fill: "black"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M270.41 377.98H276.24V375.64H270.41V377.98Z",
    fill: "black"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M268.68 345.9H274.51V343.56H268.68V345.9Z",
    fill: "black"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M271.88 343H277.71V340.66H271.88V343Z",
    fill: "black"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M251.14 360.83H256.97V358.49H251.14V360.83Z",
    fill: "black"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M248.06 357.71H253.89V355.37H248.06V357.71Z",
    fill: "black"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M254.95 390.29H260.78V387.95H254.95V390.29Z",
    fill: "black"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M275.21 345.9H281.04V343.56H275.21V345.9Z",
    fill: "black"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M259.17 286.13H253.34V288.47H259.17V286.13Z",
    fill: "black"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M233.5 288.81H227.67V291.15H233.5V288.81Z",
    fill: "black"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M238.8 301.02H232.97V303.36H238.8V301.02Z",
    fill: "black"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M241.71 304.12H235.88V306.46H241.71V304.12Z",
    fill: "black"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M247.76 336.14H241.93V338.48H247.76V336.14Z",
    fill: "black"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M244.57 339.05H238.74V341.39H244.57V339.05Z",
    fill: "black"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M231.2 311.06H225.37V313.4H231.2V311.06Z",
    fill: "black"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M241.23 336.14H235.4V338.48H241.23V336.14Z",
    fill: "black"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M279.53 302.57H273.7V304.91H279.53V302.57Z",
    fill: "black"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M274.86 305.25H269.03V307.59H274.86V305.25Z",
    fill: "black"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M235.29 169.57H229.46V171.91H235.29V169.57Z",
    fill: "black"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M278.45 161.04H272.62V163.38H278.45V161.04Z",
    fill: "black"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M282.07 197.97H276.24V200.31H282.07V197.97Z",
    fill: "black"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M278.87 200.88H273.04V203.22H278.87V200.88Z",
    fill: "black"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M254.63 165.28H248.8V167.62H254.63V165.28Z",
    fill: "black"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M257.71 168.4H251.88V170.74H257.71V168.4Z",
    fill: "black"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M282.6 220.47H276.77V222.81H282.6V220.47Z",
    fill: "black"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M275.54 197.97H269.71V200.31H275.54V197.97Z",
    fill: "black"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M233.5 216.49H239.33V214.15H233.5V216.49Z",
    fill: "black"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M238.16 213.81H243.99V211.47H238.16V213.81Z",
    fill: "black"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M247.27 261.86H253.1V259.52H247.27V261.86Z",
    fill: "black"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M255.73 220.7H261.56V218.36H255.73V220.7Z",
    fill: "black"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M251.377 259.291L257.202 259.539L257.301 257.201L251.477 256.953L251.377 259.291Z",
    fill: "black"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M253.802 256.947L259.632 257.18L259.725 254.84L253.895 254.607L253.802 256.947Z",
    fill: "black"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M252.8 197.05H258.63V194.71H252.8V197.05Z",
    fill: "black"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M249.72 193.93H255.55V191.59H249.72V193.93Z",
    fill: "black"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M251.09 242.208L256.915 242.456L257.014 240.118L251.19 239.87L251.09 242.208Z",
    fill: "black"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M257.895 259.563L263.72 259.812L263.819 257.474L257.995 257.226L257.895 259.563Z",
    fill: "black"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M201.31 177.55V403.87",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M308.55 177.55V403.87",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M276.34 127.05H279.69",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M238 127C247.84 127 257.68 127 267.52 127",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M224.46 127.05H234.69",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M245.1 129.93H240.25",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M287.06 129.93C277.58 129.97 268.1 129.97 258.62 129.93",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M284.8 133.25H287.06",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M248.59 133.25H268.09",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M228.18 133.25H245.54",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M219.4 133.25H222.3",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M252.26 129.93H253.85",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M163.93 226.16L155.12 219.61V223.16H112C110.674 223.16 109.402 222.633 108.464 221.696C107.527 220.758 107 219.486 107 218.16V211H141.71C142.721 210.997 143.69 210.594 144.405 209.878C145.119 209.161 145.52 208.191 145.52 207.18V189.79C145.52 188.779 145.119 187.808 144.405 187.092C143.69 186.376 142.721 185.973 141.71 185.97H66.27C65.7688 185.97 65.2726 186.069 64.8097 186.261C64.3467 186.453 63.9263 186.735 63.5724 187.089C63.2184 187.444 62.938 187.865 62.7471 188.329C62.5563 188.792 62.4587 189.289 62.46 189.79V207.15C62.4547 207.654 62.5493 208.153 62.7384 208.62C62.9275 209.087 63.2074 209.512 63.5617 209.87C63.916 210.228 64.3378 210.512 64.8027 210.706C65.2675 210.9 65.7663 211 66.27 211H101V219.65C101 222.178 102.004 224.603 103.791 226.392C105.578 228.181 108.002 229.187 110.53 229.19H155.14V232.75L163.93 226.16Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 192.92L77.3 196.57L81.33 197.16L78.42 200L79.11 204.02L75.5 202.13L71.89 204.02L72.58 200L69.66 197.16L73.69 196.57L75.5 192.92Z",
    fill: "#DE3C3E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M89.74 192.92L91.54 196.57L95.58 197.16L92.66 200L93.35 204.02L89.74 202.13L86.13 204.02L86.82 200L83.9 197.16L87.93 196.57L89.74 192.92Z",
    fill: "#DE3C3E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M103.98 192.92L105.78 196.57L109.82 197.16L106.9 200L107.59 204.02L103.98 202.13L100.37 204.02L101.06 200L98.14 197.16L102.17 196.57L103.98 192.92Z",
    fill: "#DE3C3E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M118.22 192.92L120.03 196.57L124.06 197.16L121.14 200L121.83 204.02L118.22 202.13L114.61 204.02L115.3 200L112.38 197.16L116.42 196.57L118.22 192.92Z",
    fill: "#DE3C3E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M132.46 192.92L134.27 196.57L138.3 197.16L135.38 200L136.07 204.02L132.46 202.13L128.85 204.02L129.54 200L126.62 197.16L130.66 196.57L132.46 192.92Z",
    fill: "#DE3C3E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M447.58 200.89V238.29C447.58 238.29 362.17 266.7 344.9 275.11C327.63 283.52 309.06 301 309.06 301C302.86 307.42 280.06 312.73 281.17 306.79C281.534 304.635 281.581 302.439 281.31 300.27C281.092 298.264 280.677 296.284 280.07 294.36C278.07 298.12 273.65 302.36 273.65 302.36C273.65 306.78 270.99 314.09 270.99 314.09L269.99 328.25C274.53 336.44 270.53 339.75 268.81 339.53C267.09 339.31 265.14 336.31 265.14 336.31L262.57 336.66C262.57 336.66 259.47 343.07 257.03 343.3C254.59 343.53 253.23 339.98 253.23 339.98C253.23 339.98 251.94 342.41 248.85 340.98C248.05 340.472 247.428 339.728 247.07 338.85C245.14 334.98 244.07 327.32 243.76 324.53C243.31 320.99 242.87 304.61 242.87 302.62C242.87 300.63 253.94 283.62 257.26 277.83C260.58 272.04 263.01 265 267.43 262.57C271.85 260.14 276.73 262.12 291.11 261.24C305.49 260.36 317.89 257.48 324.4 255.04C330.91 252.6 332.49 249.29 342.01 247.04C351.53 244.79 446.92 201.12 447.58 200.89Z",
    fill: "white"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M283.13 293C282.712 295.46 282.103 297.884 281.31 300.25C281.092 298.244 280.677 296.264 280.07 294.34C278.07 298.1 273.65 302.34 273.65 302.34C273.65 306.76 270.99 314.07 270.99 314.07L269.99 328.23C274.53 336.42 270.53 339.73 268.81 339.51C267.09 339.29 265.14 336.29 265.14 336.29L262.57 336.64C262.57 336.64 259.47 343.05 257.03 343.28C254.59 343.51 253.23 339.96 253.23 339.96C253.23 339.96 251.94 342.39 248.85 340.96C248.05 340.452 247.428 339.708 247.07 338.83C248.18 339.33 249.52 338.83 250.73 335.57C251.544 333.368 251.851 331.01 251.628 328.673C251.404 326.335 250.657 324.078 249.44 322.07C249.44 322.07 254.04 312.23 253.85 309.85C253.66 307.47 251.11 305.18 252.05 303.56C252.99 301.94 255.26 304.84 257.05 303C258.84 301.16 265.44 290.82 265.17 289.65C264.9 288.48 266.84 288.55 267.85 287.65C268.86 286.75 268.63 282.38 269.99 282.92C271.35 283.46 272.8 284.26 272.8 284.26C272.936 283.265 272.936 282.255 272.8 281.26C272.54 280.76 277.62 285.96 279.1 286.17C280.58 286.38 283.7 287.71 283.13 293Z",
    fill: "#DE3C3E"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M447.58 200.89C446.92 201.12 351.58 244.79 342.03 247.01C332.48 249.23 330.92 252.54 324.42 255.01C317.92 257.48 305.52 260.32 291.13 261.21C276.74 262.1 271.88 260.1 267.45 262.54C263.02 264.98 260.59 272.05 257.28 277.8C253.97 283.55 242.89 300.6 242.89 302.59C242.89 304.58 243.33 320.96 243.78 324.5C244.23 328.04 245.78 339.5 248.87 340.95C251.96 342.4 253.25 339.95 253.25 339.95C253.25 339.95 254.62 343.49 257.05 343.27C259.48 343.05 262.59 336.63 262.59 336.63L265.16 336.28C265.16 336.28 267.1 339.28 268.83 339.5C270.56 339.72 274.55 336.41 270.01 328.22L271.01 314.06C271.01 314.06 273.66 306.75 273.66 302.33C273.66 302.33 278.09 298.12 280.08 294.33C280.08 294.33 282.29 300.82 281.18 306.76C280.07 312.7 302.87 307.39 309.07 300.97",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M253.25 340C253.25 340 256.92 330 253.25 323.84C254.015 322.38 254.564 320.817 254.88 319.2C255.39 316.54 256.56 309.07 256.22 307.91C255.88 306.75 257.05 305.42 257.05 305.42C258.604 303.903 259.995 302.227 261.2 300.42C263.36 297.27 266.35 291.42 266.35 291.42C266.35 291.42 268.51 290.76 271.16 287.6C271.16 287.6 273.98 286.77 275.48 287.6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M280.79 288.28C280.79 288.28 282.28 293.06 280.79 296.73",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M280.07 294.36C280.07 294.36 279.46 290.77 278.13 289.6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M266.35 291.43C266.35 291.43 269.56 295.57 276.35 294.36",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M271.33 296.73C271.33 296.73 267.01 305.06 265.33 306.79L264.33 312.43",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M257.88 306.79C258.712 307.176 259.618 307.376 260.535 307.376C261.452 307.376 262.358 307.176 263.19 306.79",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M273.65 302.33C273.65 302.33 270.28 305.33 268.83 304.58",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M268.83 283C270.175 284.193 271.009 285.858 271.16 287.65",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M272.18 279.65C271.99 280.14 274.48 284.29 276.31 286.12",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M252.07 304.69C252.801 305.167 253.629 305.475 254.493 305.593C255.358 305.71 256.238 305.634 257.07 305.37",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M250.75 323.29C250.75 323.29 253.55 323.5 254.05 322.02",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M258.237 352.529C262.569 352.111 265.651 347.32 265.121 341.828C264.591 336.337 260.65 332.223 256.318 332.641C251.986 333.059 248.904 337.85 249.434 343.342C249.964 348.834 253.905 352.947 258.237 352.529Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M258.37 352.08C257.67 350.528 256.525 349.219 255.081 348.317C253.637 347.415 251.958 346.962 250.256 347.014C248.555 347.067 246.907 347.623 245.521 348.612C244.135 349.6 243.073 350.978 242.47 352.57L236.74 367.7C235.932 369.836 236.007 372.206 236.946 374.288C237.886 376.369 239.614 377.992 241.75 378.8C243.886 379.608 246.256 379.533 248.338 378.594C250.419 377.654 252.042 375.926 252.85 373.79L258.57 358.67C258.973 357.613 259.163 356.486 259.128 355.355C259.094 354.224 258.836 353.111 258.37 352.08ZM251.89 351.99C251.621 351.886 251.389 351.705 251.222 351.469C251.056 351.233 250.964 350.953 250.957 350.664C250.95 350.376 251.028 350.092 251.182 349.848C251.337 349.604 251.56 349.411 251.823 349.294C252.087 349.177 252.38 349.14 252.664 349.189C252.948 349.238 253.212 349.37 253.421 349.569C253.631 349.768 253.776 350.024 253.84 350.305C253.904 350.587 253.883 350.881 253.78 351.15C253.641 351.513 253.364 351.805 253.01 351.965C252.656 352.124 252.253 352.137 251.89 352V351.99Z",
    fill: "#DE3C3E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M256.25 357.79L250.53 372.91C249.913 374.369 248.754 375.533 247.298 376.157C245.841 376.781 244.2 376.816 242.718 376.256C241.235 375.696 240.028 374.584 239.347 373.153C238.667 371.722 238.568 370.083 239.07 368.58L244.79 353.45C245.288 352.127 246.237 351.022 247.47 350.33C247.782 351.172 248.27 351.937 248.903 352.574C249.536 353.21 250.298 353.704 251.138 354.02C251.978 354.337 252.877 354.47 253.772 354.409C254.668 354.349 255.54 354.097 256.33 353.67C256.779 355.012 256.75 356.467 256.25 357.79Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M249.12 370C248.814 369.99 248.514 369.915 248.24 369.78L247.16 369.37C246.52 369.12 246.16 369.25 246.01 369.74L245.87 370.12L248.67 371.19L248.26 372.27L241.37 369.64L242 368C242.047 367.769 242.147 367.552 242.294 367.367C242.441 367.182 242.629 367.035 242.844 366.937C243.059 366.84 243.294 366.794 243.53 366.805C243.765 366.816 243.995 366.883 244.2 367L244.74 367.21C245.031 367.279 245.293 367.434 245.493 367.655C245.693 367.877 245.821 368.154 245.86 368.45C246.29 367.99 246.86 368.01 247.59 368.28L248.65 368.69C248.929 368.818 249.233 368.887 249.54 368.89L249.12 370ZM242.76 368.93L244.88 369.74L245.04 369.32C245.2 368.91 245.11 368.6 244.56 368.39L243.88 368.13C243.39 367.94 243.11 368.03 242.96 368.41L242.76 368.93Z",
    fill: "#DE3C3E"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M246.2 365.7L246.76 364.21L247.76 364.59L247.19 366.08L249.19 366.85L249.9 364.98L250.9 365.35L249.77 368.35L242.88 365.72L244 362.72L245 363.1L244.29 364.97L246.2 365.7Z",
    fill: "#DE3C3E"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M246.54 361.79L251.54 363.69L251.17 364.69L244.28 362.06L244.79 360.7L249.34 361.18L245.21 359.61L245.58 358.61L252.47 361.24L252.05 362.36L246.54 361.79Z",
    fill: "#DE3C3E"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M245.75 358.16L247.02 354.81L248.02 355.18L247.59 356.32L253.5 358.57L253.08 359.65L247.17 357.4L246.74 358.53L245.75 358.16Z",
    fill: "#DE3C3E"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M257.66 348.66L246 354.13C245.753 354.238 245.529 354.394 245.344 354.591C245.159 354.787 245.015 355.018 244.922 355.272C244.828 355.525 244.787 355.794 244.8 356.064C244.814 356.333 244.882 356.597 245 356.84L252.16 372.18C252.268 372.428 252.424 372.651 252.621 372.836C252.817 373.021 253.048 373.165 253.302 373.258C253.555 373.352 253.824 373.393 254.094 373.38C254.363 373.366 254.627 373.298 254.87 373.18L258.27 371.59L270.47 397.72C270.549 397.89 270.66 398.042 270.797 398.169C270.935 398.295 271.096 398.393 271.272 398.458C271.447 398.522 271.634 398.55 271.821 398.542C272.007 398.534 272.191 398.489 272.36 398.41L274.69 397.32C274.86 397.242 275.012 397.13 275.139 396.993C275.265 396.855 275.363 396.694 275.427 396.518C275.492 396.343 275.52 396.156 275.512 395.969C275.504 395.783 275.459 395.599 275.38 395.43L263.18 369.3L266.59 367.71C266.837 367.602 267.061 367.446 267.246 367.25C267.431 367.053 267.575 366.822 267.668 366.569C267.762 366.315 267.803 366.046 267.79 365.776C267.776 365.507 267.708 365.243 267.59 365L260.43 349.65C260.322 349.396 260.162 349.166 259.961 348.977C259.76 348.787 259.522 348.641 259.262 348.548C259.002 348.455 258.725 348.417 258.449 348.436C258.174 348.455 257.905 348.532 257.66 348.66ZM259.66 351.91C259.756 352.114 259.811 352.334 259.822 352.559C259.833 352.784 259.8 353.009 259.723 353.22C259.647 353.432 259.53 353.627 259.378 353.793C259.227 353.96 259.044 354.095 258.84 354.19L258.47 354.36C258.059 354.551 257.589 354.57 257.163 354.415C256.738 354.259 256.391 353.941 256.2 353.53L256.03 353.17C255.838 352.759 255.817 352.288 255.97 351.861C256.124 351.434 256.44 351.085 256.85 350.89L257.22 350.72C257.424 350.626 257.645 350.573 257.87 350.564C258.094 350.556 258.318 350.591 258.529 350.669C258.74 350.747 258.933 350.866 259.098 351.019C259.263 351.172 259.396 351.356 259.49 351.56L259.66 351.91Z",
    fill: "#BFBFBF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M272.6 395.94L260.61 370.25L261.86 369.67",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M265.11 341.85C265.64 347.34 262.55 352.13 258.22 352.54",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M447.58 209.52V252.67L444.19 253.55C427.86 257.79 358.34 275.84 352.68 277.99C346.26 280.42 339.85 284.18 337.68 284.62C335.51 285.06 323.96 298.12 320.42 301.44C316.88 304.76 308.25 308.52 298.29 311.18C288.33 313.84 279.04 320.92 276.61 323.13C274.18 325.34 261.78 342.13 258.9 340.83C256.64 339.78 253.4 339.15 253.33 334.38C253.348 332.745 253.587 331.121 254.04 329.55C256.47 320.25 261.78 312.95 266.87 311.18C271.96 309.41 284.13 293.7 284.57 289.71L447.58 209.52Z",
    fill: "white"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M444.16 253.55C427.83 257.79 358.31 275.84 352.65 277.99C346.23 280.42 339.82 284.18 337.65 284.62C335.48 285.06 323.93 298.12 320.39 301.44C316.85 304.76 308.22 308.52 298.26 311.18C288.3 313.84 279.01 320.92 276.58 323.13C274.15 325.34 261.75 342.13 258.87 340.83C256.61 339.78 253.37 339.15 253.3 334.38C254.73 336.65 257.01 339.29 257.93 338.29C257.93 338.29 255.24 338.09 257.93 331.56C260.62 325.03 261.93 321.87 265.23 324.24C268.53 326.61 272.38 327.41 273.71 322.66C275.04 317.91 275.52 320.09 281.51 316.13C287.5 312.17 293.83 305.53 295.61 305.69C297.39 305.85 311.24 304.54 315.39 302.33C319.54 300.12 331.39 286.79 331.7 282.96C332.01 279.13 346.79 273.6 350.48 271.43C354.17 269.26 368.6 266.48 374.14 265.3C379.68 264.12 365.83 269.18 361.68 272.08C357.53 274.98 396.68 262.13 406.97 260.15C417 258.22 443.14 253.73 444.16 253.55Z",
    fill: "#DE3C3E"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M447.58 252.67C447.58 252.67 359.07 275.55 352.65 278C346.23 280.45 339.82 284.19 337.65 284.63C335.48 285.07 323.93 298.13 320.39 301.45C316.85 304.77 308.22 308.53 298.26 311.19C288.3 313.85 279.01 320.93 276.58 323.14C274.15 325.35 261.75 342.14 258.87 340.84C255.99 339.54 251.57 338.84 254.01 329.56C256.45 320.28 261.75 312.96 266.84 311.19C271.93 309.42 284.1 293.71 284.54 289.72",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M291.63 418.46C286.23 423.88 269.89 431.61 264.04 435.76C259.9 438.7 242.65 441.37 237.63 442.84C234.07 443.89 229.32 447.97 224.57 446.62C219.82 445.27 180.26 426.27 170.77 421.53C161.28 416.79 112.22 424.23 82.95 423.27C81.04 423.21 79.21 423.15 77.46 423.11C52.27 422.44 42.59 423.27 42.59 423.27L56.04 371.27C56.04 371.27 81 372.47 119 379.2C126.67 380.56 133.62 381.65 139.84 382.54C164.44 386.05 177.54 386.29 177.54 386.29C177.54 386.29 190.2 375.29 202.07 384.74C213.94 394.19 217.07 402.14 217.07 402.14L233.69 411.64C233.69 411.64 240.42 410.45 244.57 411.64C248.72 412.83 254.57 408.87 257.57 407.29C262.861 404.62 268.57 402.878 274.45 402.14C274.45 402.14 284.68 398.19 292.2 400.14C292.2 400.14 297.74 397.77 302.49 397.77C303.719 397.757 304.937 398.01 306.06 398.51C307.337 399.067 308.43 399.976 309.21 401.13C309.56 402.499 309.824 403.888 310 405.29C310.42 408.08 303.69 406.34 291.63 418.46Z",
    fill: "white"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M291.63 418.46C286.23 423.88 269.89 431.61 264.04 435.76C259.9 438.7 242.65 441.37 237.63 442.84C234.07 443.89 229.32 447.97 224.57 446.62C219.82 445.27 180.26 426.27 170.77 421.53C161.28 416.79 112.22 424.23 82.95 423.27C81.04 423.21 79.21 423.15 77.46 423.11C90.12 422.28 103.46 421.31 107.57 420.64C116.01 419.25 158.11 417.08 163.96 416.58C169.81 416.08 215.96 440.09 221.24 442.46C226.52 444.83 230.24 445.1 233.67 442.46C237.1 439.82 250.75 437.46 250.75 437.46L242.89 438.17C242.89 438.17 253.34 434.39 260.12 432.71C266.9 431.03 273.64 424.9 278.12 423.48C282.6 422.06 290.38 413.17 294.29 411.34C298.2 409.51 294.29 404.08 294.29 404.08C294.29 404.08 299.02 403.9 300.88 406.83C300.88 406.83 307.8 407.06 309.22 401.16C309.57 402.529 309.834 403.918 310.01 405.32C310.42 408.08 303.69 406.34 291.63 418.46Z",
    fill: "#DE3C3E"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M306.08 398.53C294.65 401.53 292.22 403.44 292.22 403.44C290.14 402.82 276.63 411.34 275.48 412.03C274.33 412.72 273.65 416.03 273.65 416.03C273.65 416.03 269.77 412.03 263.19 416.62C256.61 421.21 255.89 424.06 255.89 424.06L253.25 420.68C253.25 420.68 242.08 421.68 238.67 421.13C235.854 420.771 233.178 419.693 230.9 418C228.29 416.26 214.41 410.42 212.98 410C211.55 409.58 209.74 406.92 209.74 406.92C207.21 396.76 194.6 385.16 187.74 386.08C183.606 386.648 179.678 388.236 176.31 390.7C176.31 390.7 163.47 389.38 156.88 389.12C150.29 388.86 110.2 381.47 110.2 381.47L139.78 382.47C164.38 385.98 177.48 386.22 177.48 386.22C177.48 386.22 190.14 375.22 202.01 384.67C213.88 394.12 217.01 402.07 217.01 402.07L233.63 411.57C233.63 411.57 240.36 410.38 244.51 411.57C248.66 412.76 254.51 408.8 257.51 407.22C262.801 404.55 268.51 402.808 274.39 402.07C274.39 402.07 284.62 398.12 292.14 400.07C292.14 400.07 297.68 397.7 302.43 397.7C303.693 397.704 304.939 397.987 306.08 398.53Z",
    fill: "#DE3C3E"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M187.81 414.31C187.81 414.31 187.88 417.11 186.42 416.85C184.96 416.59 189.07 420.7 191.7 420.04C194.33 419.38 200.8 425.32 203.31 427.96C205.82 430.6 227.64 434.02 232.31 433.89C236.98 433.76 240.5 428.95 237.21 424.1C237.21 424.1 236.61 428.88 233.69 428.35C233.69 428.35 236.49 427.3 232.31 423.35C228.13 419.4 221.92 417.68 220.6 418.47C219.28 419.26 211.26 415.97 210.79 415.47C210.32 414.97 211.5 426.88 204.51 426.47C204.51 426.47 196.68 420.69 195.12 418.3C193.56 415.91 187.81 414.31 187.81 414.31Z",
    fill: "#DE3C3E"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M56 371.29C56 371.29 81 372.47 119 379.2C157 385.93 177.54 386.29 177.54 386.29C177.54 386.29 190.2 375.29 202.07 384.74C213.94 394.19 217.07 402.14 217.07 402.14L233.69 411.64C233.69 411.64 240.42 410.45 244.57 411.64C248.72 412.83 254.57 408.87 257.57 407.29C262.861 404.62 268.57 402.878 274.45 402.14C274.45 402.14 284.68 398.19 292.2 400.14C292.2 400.14 297.74 397.77 302.49 397.77C303.802 397.724 305.104 398.007 306.278 398.594C307.452 399.181 308.46 400.053 309.21 401.13C309.56 402.499 309.824 403.888 310 405.29C310.4 408.06 303.67 406.29 291.61 418.44C286.21 423.86 269.87 431.59 264.02 435.74C259.88 438.68 242.63 441.35 237.61 442.82C234.05 443.87 229.3 447.95 224.55 446.6C219.8 445.25 180.24 426.25 170.75 421.51C161.26 416.77 112.2 424.21 82.93 423.25C53.66 422.29 42.57 423.25 42.57 423.25",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M241.19 418.56H253.45C253.45 418.56 263.93 414.56 271.85 412.43C271.85 412.43 283.32 404.91 287.08 403.73C290.84 402.55 295.19 403.73 296.77 405.9C297.751 407.387 298.299 409.119 298.35 410.9C298.35 410.9 287.27 418.15 284.11 420.9C280.95 423.65 274.22 426.24 266.9 430.99C259.58 435.74 246.26 435.99 241.19 438.9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M292.22 400.16C292.22 400.16 279.39 404.9 273.54 411.33",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M269.77 412C269.77 412 260.18 414.57 253.25 416.55",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M246.73 411.83C246.73 411.83 245.85 413.02 246.73 415.49",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M186.4 413.66C186.4 413.66 191.14 415.79 193.71 417.18C196.28 418.57 199.35 425.38 202.81 426.97C206.27 428.56 211.71 429.24 218.81 430.23C225.91 431.22 235.45 433 237 426.77C238.55 420.54 227.81 416.48 222.27 413.66C219.319 412.093 216.19 410.888 212.95 410.07C212.95 410.07 210.2 407.48 209.21 406.49C208.22 405.5 208.21 400.36 207.21 397.69",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M211.79 400.16C211.79 400.16 211.53 404.61 209.79 406.99",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M230.9 416C231.524 414.38 232.465 412.9 233.67 411.65",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M185 416.58C185 416.58 190.28 417.77 192.61 416.58",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M214.19 405.21C213.558 406.555 212.537 407.68 211.26 408.44",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M209.74 416.58C209.74 416.58 210.53 421.92 205.98 424.69",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApartmentRentBro);
export default __webpack_public_path__ + "static/media/Apartment-rent-bro.d79649fb10bdb1ef0f89008459c47257.svg";
export { ForwardRef as ReactComponent };